export default __webpack_public_path__ + "static/media/image_cta.59226b4f.png";